export const staticAssetPath = (path: string) => `/static-assets/${path}`;
